const afterSwapInitializers = new Set();
let lifecycleReady = false;

const requestElement = (event) => event.detail?.elt ?? event.target;

const setRequestBusy = (event, busy) => {
    const element = requestElement(event);
    if (!(element instanceof HTMLElement)) {
        return;
    }

    if (busy) {
        if (!element.hasAttribute("data-rcd-previous-busy")) {
            element.dataset.rcdPreviousBusy = element.getAttribute("aria-busy") ?? "";
        }
        element.setAttribute("aria-busy", "true");
        element.classList.add("rcd-request-pending");
        return;
    }

    const previous = element.dataset.rcdPreviousBusy;
    if (previous) {
        element.setAttribute("aria-busy", previous);
    } else {
        element.removeAttribute("aria-busy");
    }
    delete element.dataset.rcdPreviousBusy;
    element.classList.remove("rcd-request-pending");
};

const notifyRequestError = (event) => {
    const detail = {
        sourceEvent: event,
        status: event.detail?.xhr?.status ?? 0,
        path: event.detail?.pathInfo?.requestPath ?? ""
    };

    document.dispatchEvent(new CustomEvent("rcd:htmx-error", { detail }));
};

const runAfterSwapInitializers = (event) => {
    const target = event.detail?.target ?? event.target ?? document;
    window.requestAnimationFrame(() => {
        afterSwapInitializers.forEach((initializer) => initializer(target, event));
    });
};

const installLifecycle = () => {
    if (lifecycleReady) {
        return;
    }

    lifecycleReady = true;
    document.body.addEventListener("htmx:beforeRequest", (event) => setRequestBusy(event, true));
    document.body.addEventListener("htmx:afterRequest", (event) => setRequestBusy(event, false));
    document.body.addEventListener("htmx:sendError", notifyRequestError);
    document.body.addEventListener("htmx:responseError", notifyRequestError);
    document.body.addEventListener("htmx:timeout", notifyRequestError);
    document.body.addEventListener("htmx:afterSwap", runAfterSwapInitializers);
};

export const setupRcdHtmxLifecycle = (initializer) => {
    if (typeof initializer === "function") {
        afterSwapInitializers.add(initializer);
    }

    installLifecycle();

    return () => {
        if (typeof initializer === "function") {
            afterSwapInitializers.delete(initializer);
        }
    };
};
